import TdsStatCard from "./TdsStatCard";
import { Building2, IndianRupee, Users, Wallet } from "lucide-react";
import { formatINR } from "../tdsConstants";

export default function TdsReportsSummary({ stats, summary }) {
  if (!summary) return null;
  return (
    <section className="tdsr-summary" aria-label="Report summary">
      <TdsStatCard
        label="Total Employees"
        value={stats?.total ?? summary.rowCount}
        icon={Users}
        accent="#7c3aed"
        bg="#ede9fe"
        color="#5b21b6"
      />
      <TdsStatCard
        label="Employees with TDS"
        value={summary.withTds}
        icon={Wallet}
        accent="#059669"
        bg="#d1fae5"
        color="#047857"
      />
      <TdsStatCard
        label="Gross Salary"
        value={formatINR(summary.gross)}
        icon={IndianRupee}
        accent="#2563eb"
        bg="#dbeafe"
        color="#1d4ed8"
      />
      <TdsStatCard
        label="Taxable Salary"
        value={formatINR(summary.taxable)}
        icon={IndianRupee}
        accent="#d97706"
        bg="#fef3c7"
        color="#b45309"
      />
      <TdsStatCard
        label="Annual Tax"
        value={formatINR(summary.annualTax)}
        icon={IndianRupee}
        accent="#dc2626"
        bg="#fee2e2"
        color="#b91c1c"
      />
      <TdsStatCard
        label="Monthly TDS"
        value={formatINR(summary.monthlyTds)}
        icon={IndianRupee}
        accent="#7c3aed"
        bg="#ede9fe"
        color="#5b21b6"
      />
      <TdsStatCard
        label="Departments"
        value={summary.deptCount}
        icon={Building2}
        accent="#0891b2"
        bg="#cffafe"
        color="#0e7490"
      />
      <TdsStatCard
        label="Processed"
        value={summary.rowCount}
        icon={Users}
        accent="#64748b"
        bg="#f1f5f9"
        color="#334155"
      />
    </section>
  );
}
